import React, { PureComponent } from 'react';
import classnames from 'classnames';
import CopyLinkToClipboard from '../CopyLinkToClipboard/CopyLinkToClipboard';
import SocialShareWrapper from './SocialShareWrapper';
import TourSharePublishWarning from '../TourEditorContainer/TourEditor/TourSharePublishContainer/TourSharePublishWarning/TourSharePublishWarning';
import Button from '../Buttons/Button';
import './Share.scss';
import LanguageSelect from './LanguageSelect/LanguageSelect';

class Share extends PureComponent {
  constructor() {
    super();
    this.state = {
      shareView: 'pano',
      shareLang: '',
    };
  }

  componentDidMount() {
    const { permissions } = this.props;
    if (permissions?.multiLanguage) {
      this.setState({
        shareLang: 'en',
      });
    }
  }

  setShareView = view => {
    this.setState({
      shareView: view,
    });
  };

  setShareLang = e => {
    this.setState({
      shareLang: e.target.value,
    });
  };

  handlePublishNow = () => {
    const { tourId, history, closeModal } = this.props;
    if (typeof closeModal() === 'function') closeModal();
    history.push(`/home/${tourId}/edit/publish`);
  };

  renderPublishBtn = () => {
    return (
      <Button
        className="publish-now text-btn"
        handleClick={this.handlePublishNow}
      >
        <i className="material-icons">open_in_new</i>
        &nbsp;Go Publish
      </Button>
    );
  };

  renderSocialShareBtns = shareUrl => {
    const { tourId, tourName, aid } = this.props;
    return (
      <SocialShareWrapper
        buttonTypesArray={['facebook', 'X', 'linkedin']}
        shareUrl={shareUrl}
        tourId={tourId}
        tourName={tourName}
        aid={aid}
      />
    );
  };

  createShareUrl = () => {
    const { tourId, stopNumber = 1 } = this.props;
    const { shareView, shareLang } = this.state;
    const viewParam = shareView === 'map' ? '?mv' : '';
    const lang = shareLang ? `${shareLang}/` : '';
    return `${window.location.origin}/${lang}share/${tourId}/stop/${stopNumber}${viewParam}`;
  };

  render() {
    const { shareView, shareLang } = this.state;
    const {
      aid,
      embed,
      languages,
      permissions,
      published,
      sendHubspotEvent,
      showPublishButton,
      tourEditor,
      tourId,
      tourName,
      uptoDate,
    } = this.props;

    const shareUrl = this.createShareUrl();

    const iframeEmbed = `
      <iframe src="${shareUrl}" width="100%" height="100%" border="0" scroll="no" allowfullscreen>
        Your browser does not support Iframes
      </iframe>
    `;

    return (
      <section className="share-wrapper">
        <h2>Share Tour</h2>
        {tourEditor && (
          <p className="tour-editer-note">
            Generate share and embed URLs of your tour when are ready to show
            them to the world. Changes that have not been published will not be
            visible on public share URLs and embeds.
          </p>
        )}
        {published ? (
          <React.Fragment>
            <h3>Tour View</h3>
            <p>
              Set the share link and embed code to initially show the tour media
              or map.
            </p>
            <div className="share-view-buttons">
              <Button
                className={classnames('share-view-button', {
                  active: shareView === 'pano',
                })}
                handleClick={() => this.setShareView('pano')}
                aria-pressed={shareView === 'pano'}
                data-cy="share-view-btn-pano"
              >
                Media View
              </Button>
              <Button
                className={classnames('share-view-button', {
                  active: shareView === 'map',
                })}
                handleClick={() => this.setShareView('map')}
                aria-pressed={shareView === 'map'}
                data-cy="share-view-btn-map"
              >
                Map View
              </Button>
            </div>
            {permissions?.multiLanguage && (
              <LanguageSelect
                languages={languages}
                handleChange={this.setShareLang}
                selectedLang={shareLang}
                tourId={tourId}
              />
            )}
            <span className="share-url">
              <span className="share-label">
                <i aria-hidden="true" className="material-icons">
                  link
                </i>
                &nbsp;
                <h4 className="share-heading-4">
                  Share Link
                </h4>
              </span>
              <span className="share-url-contents" data-cy="share-url">
                {shareUrl}
              </span>
              <CopyLinkToClipboard
                shareUrl={shareUrl}
                tourId={tourId}
                tourName={tourName}
                type="share"
                aid={aid}
                sendHubspotEvent={sendHubspotEvent}
              />
            </span>
            {this.renderSocialShareBtns(shareUrl)}
            {embed && (
              <span data-cy="embed-url" className="embed-url">
                <span className="share-label">
                  <i aria-hidden="true" className="material-icons">
                    code
                  </i>
                  &nbsp;
                  <h4>Embed iframe</h4>
                </span>
                <span>{iframeEmbed}</span>
                <CopyLinkToClipboard
                  shareUrl={iframeEmbed}
                  tourId={tourId}
                  tourName={tourName}
                  type="embed"
                  sendHubspotEvent={sendHubspotEvent}
                />
              </span>
            )}
            {!uptoDate && (
              <TourSharePublishWarning>
                <p>
                  There are unpublished changes that are not visible using
                  public share urls.
                </p>
                {showPublishButton && this.renderPublishBtn()}
              </TourSharePublishWarning>
            )}
          </React.Fragment>
        ) : (
          <TourSharePublishWarning>
            <p>
              This tour is unpublished. Please publish your tour to produce a
              share url
            </p>
          </TourSharePublishWarning>
        )}
      </section>
    );
  }
}

export default Share;
